export default __webpack_public_path__ + "static/media/message.3c0ca7b4.svg";